<template>
  <div class="v-layout-loading">
    <v-spinner
      line-fg-color="var(--blue-grey-300)"
      line-bg-color="var(--blue-grey-200)"
      class="spinner"
    />
  </div>
</template>

<script>
export default {
  name: "VLayoutLoading"
};
</script>
